import { render, staticRenderFns } from "./LegacyMetaData.vue?vue&type=template&id=fdc18ad2&scoped=true&lang=html&"
import script from "./LegacyMetaData.vue?vue&type=script&lang=js&"
export * from "./LegacyMetaData.vue?vue&type=script&lang=js&"
import style0 from "./LegacyMetaData.vue?vue&type=style&index=0&id=fdc18ad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc18ad2",
  null
  
)

export default component.exports